import DirectoryServicesPage from './DirectoryServicesPage';
import DirectoryServiceDescriptionPage from './DirectoryServiceDescriptionPage';
import DirectoryServicesMappingsPage from './DirectoryServicesMappingsPage';

export default DirectoryServicesPage;
export { DirectoryServiceDescriptionPage, DirectoryServicesMappingsPage };



// WEBPACK FOOTER //
// ./src/view/Pages/DirectoryServicesPage/index.js